var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettingsSd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16449_141192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4H9.0058C8.77313 4 8.66716 4 7.79689 6.37628L7.76413 6.46278L6.94501 6.80364L6.86669 6.7704C5.51584 6.18906 4.7271 5.89427 4.5215 5.89427C4.43807 5.89427 4.34071 5.93248 4.28522 5.98827L2.93267 7.33777C2.76109 7.51053 2.68992 7.58288 3.75602 9.87921L3.7952 9.96437L3.46027 10.7783L3.3783 10.8106C1 11.7488 1 11.8403 1 12.0847V13.9935C1 14.2385 1 14.3403 3.38302 15.2121L3.4682 15.2428L3.80319 16.0543L3.76722 16.1372C2.7547 18.4824 2.81836 18.547 2.99062 18.7219L2.99089 18.7222L4.34013 20.0697C4.39669 20.1252 4.49458 20.1648 4.57806 20.1648C4.6536 20.1648 4.88335 20.1648 6.88042 19.2426L6.96039 19.2044L7.78433 19.5445L7.81636 19.6286C8.75546 22 8.85193 22 9.08563 22H10.9945C11.2342 22 11.3336 22 12.2046 19.6221L12.237 19.5356L13.0575 19.197L13.1355 19.2295C14.4853 19.8125 15.2736 20.1067 15.4779 20.1067C15.5606 20.1067 15.6588 20.0697 15.7153 20.0126L17.07 18.6602L17.0702 18.66C17.2405 18.4865 17.311 18.4146 16.2434 16.1214L16.2037 16.0352L16.5381 15.2248L16.6179 15.1929C19 14.2498 19 14.1579 19 13.9132V12.0055C19 11.8059 19 11.7017 17.7102 11.2H12.5134C12.8776 11.7075 13.0923 12.3293 13.0923 13.0005C13.0923 14.7065 11.7051 16.096 10.0003 16.096C8.29482 16.096 6.90736 14.7068 6.90736 13.0005C6.90736 11.2942 8.2947 9.90691 10 9.90675V4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16449_141192)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 12,
    height: 10,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gray",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 0C11.5373 0 11 0.559644 11 1.25V8.75C11 9.44036 11.5373 10 12.2 10H21.8C22.4627 10 23 9.44036 23 8.75V1.25C23 0.559644 22.4627 0 21.8 0H12.2ZM13.4511 7.365C13.7439 7.49 14.0751 7.5525 14.4447 7.5525C14.8239 7.5525 15.1527 7.48 15.4311 7.335C15.7095 7.19 15.9207 6.995 16.0647 6.75C16.2135 6.505 16.2879 6.2325 16.2879 5.9325C16.2879 5.6175 16.2135 5.36 16.0647 5.16C15.9159 4.96 15.7383 4.8075 15.5319 4.7025C15.3303 4.5975 15.0663 4.4875 14.7399 4.3725C14.4135 4.2625 14.1735 4.16 14.0199 4.065C13.8663 3.97 13.7895 3.8375 13.7895 3.6675C13.7895 3.5125 13.8351 3.395 13.9263 3.315C14.0175 3.23 14.1375 3.1875 14.2863 3.1875C14.4591 3.1875 14.6007 3.2375 14.7111 3.3375C14.8215 3.4325 14.8815 3.565 14.8911 3.735H16.2231C16.1991 3.24 16.0167 2.855 15.6759 2.58C15.3351 2.3 14.8863 2.16 14.3295 2.16C13.7823 2.16 13.3383 2.3 12.9975 2.58C12.6567 2.855 12.4863 3.2375 12.4863 3.7275C12.4863 4.0575 12.5607 4.325 12.7095 4.53C12.8583 4.735 13.0359 4.89 13.2423 4.995C13.4487 5.1 13.7151 5.205 14.0415 5.31C14.2671 5.38 14.4399 5.4425 14.5599 5.4975C14.6847 5.5525 14.7879 5.6225 14.8695 5.7075C14.9559 5.7925 14.9991 5.9 14.9991 6.03C14.9991 6.185 14.9463 6.3075 14.8407 6.3975C14.7351 6.4825 14.5911 6.525 14.4087 6.525C14.2311 6.525 14.0871 6.475 13.9767 6.375C13.8663 6.27 13.8015 6.12 13.7823 5.925H12.4719C12.4815 6.27 12.5727 6.565 12.7455 6.81C12.9231 7.055 13.1583 7.24 13.4511 7.365ZM20.336 2.565C19.9376 2.345 19.472 2.235 18.9392 2.235H17.0456V7.5H18.9392C19.4672 7.5 19.9304 7.39 20.3288 7.17C20.732 6.95 21.0416 6.64 21.2576 6.24C21.4784 5.84 21.5888 5.3825 21.5888 4.8675C21.5888 4.3475 21.4784 3.89 21.2576 3.495C21.0416 3.095 20.7344 2.785 20.336 2.565ZM19.9472 5.9925C19.688 6.2575 19.3256 6.39 18.86 6.39H18.2768V3.33H18.86C19.3256 3.33 19.688 3.465 19.9472 3.735C20.2064 4.005 20.336 4.3825 20.336 4.8675C20.336 5.3525 20.2064 5.7275 19.9472 5.9925Z",
    fill: "#FF443A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16449_141192",
    x: 0,
    y: 4,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16449_141192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16449_141192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16449_141192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 12,
    height: 10,
    rx: 2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsSd);
export default __webpack_public_path__ + "static/media/icon-settings-sd.fcb769e0906bb3aabae7d4066d05165a.svg";
export { ForwardRef as ReactComponent };